import React from 'react';
import cn from 'classnames';

import { UiKit } from 'components';
import * as TableCell from '.';

export default function TableCellToggleGrid({
  isActive = false,
  onChange = () => {},
  disabled = false,
  tooltipMessage = '',
  title = null,
  caption = null,
  className = '',
  titleClassName = '',
  captionClassName = ''
}) {
  return (
    <UiKit.Grid
      templateColumns="auto 1fr"
      gap="16"
      className={cn({ 'align-items-center': !caption }, className)}
    >
      <UiKit.Toggle
        isActive={isActive}
        onChange={onChange}
        disabled={disabled}
        tooltipMessage={tooltipMessage}
      />
      <TableCell.Column>
        <TableCell.Text weight="bold" className={titleClassName}>
          {title}
        </TableCell.Text>
        <TableCell.Text size="sm" variant="muted" className={captionClassName}>
          {caption}
        </TableCell.Text>
      </TableCell.Column>
    </UiKit.Grid>
  );
}
